import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageFullwidth } from 'components/page/sections/page-section-two-columns-image-fullwidth';
import { SectionContentLinkList } from 'components/section-content-link-list';
import { SectionContentLinkListIdSeven } from 'components/section-content-link-list/section-content-link-list.enums';
import { FormattedText, P1 } from 'components/typography';

export const TabSevenContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdSeven.TipsToKeepYourDataSecure,
      text: sections.tabSevenSection.tab.list()[0],
    },
    {
      id: SectionContentLinkListIdSeven.AgeRestrictionPolicy,
      text: sections.tabSevenSection.tab.list()[1],
    },
  ];
  const props = {
    columnLeft: {
      title: sections.tabSevenSection.tab.title(),
      content: (
        <FormattedText>
          <P1 html={sections.tabSevenSection.tab.text()} as="p" />
          <P1 html={sections.tabSevenSection.tab.introList()} as="div" />
        </FormattedText>
      ),
    },
    columnRight: {
      title: sections.tabSevenSection.tab.listTitle(),
      content: <SectionContentLinkList list={list} />,
    },
    image: {
      src: `${CdnImagePath}/assets/tab-07/tab-07-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageFullwidth {...props} />;
};
